module.exports = __webpack_public_path__ + "img/荔枝壳.e75a51de.jpg";